import { api } from './api'
import type { Drill, DrillSequence, GetNextActionResult } from '@acepoker/contract'

export const getNextAction = async (
  drillTemplate: Pick<Drill, 'gaming_configuration' | 'max_players' | 'starting_stack'> &
    Pick<DrillSequence, 'sequence'> & {
      anteMultiplier?: number
      skipPreflop?: boolean
      noBlinds?: boolean
    }
): Promise<GetNextActionResult> =>
  await api().url('/api/drill/get-next-action').post(drillTemplate).json()
